import React from "react";
// eslint-disable-next-line import/no-extraneous-dependencies
import parse from "html-react-parser";

type Props = {
    htmlString: string;
};

const HtmlToReact = ({ htmlString }: Props) => {
    return <>{parse(htmlString)}</>;
};

export default HtmlToReact;
